module.exports = __webpack_public_path__ + "img/savings-providers.7a1fa57.webp";